'use client'

import type { FC } from 'react'
import DateRangeArrayPicker from 'components/datetime/DateRangeArrayPicker'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const DateRangeArrayField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <DateRangeArrayPicker
                fieldName={field.name}
                label={field.label as string}
                dateRangeArray={((value as { start?: string; end?: string }[]) || []).map(r => ({ start: r?.start ?? '', end: r?.end ?? '' }))}
                handleChange={v => onChange(field.name, v, field)}
            />
        </FieldWrapper>
    )
}

export default DateRangeArrayField
